import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { GoalsPageLayout } from 'Views/Page/Content/Templates/goalsPage/GoalsPageLayout';
import { GoalsPageMetaOverride } from 'Views/Page/Content/Templates/goalsPage/metaOverride';

const GoalsPage = ({ resource: pageResource }) => {
  return (
    <MetaResourceRenderer resource={pageResource} layout={GoalsPageLayout} metaOverrideSet={GoalsPageMetaOverride} />
  );
};

GoalsPage.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export { GoalsPage };
